export const Globals = {
    version: process.env.REACT_APP_VERSION || "3",
    audio: {
        path: "/audio",
        extensions: ["ogg", "mp3"]
    }
};